export class TransactionScheduledReceiptModel {
    nome: string;
    iSPBNome: string;
    agencia: string;
    numeroConta: string;
    documento: string;
    valor: number;
    dataAgendadaTransacao: string;
    tipoTransacao: string; 
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-response/models/transaction-scheduled-receipt.model.ts